const getVariantInventory = (item) => {
  const variant = document
    .querySelector('select[name="id"]')
    ?.querySelector(`option[value="${item.variant_id}"]`);

  const baseCartData = JSON.parse(
    document.querySelector(".quick-cart-wrap").dataset.quickCartItemsValue
  );

  const quantity =
    variant?.dataset.inventory ||
    baseCartData?.find((lineItem) => lineItem.key === item.key)
      ?.inventory_quantity ||
    null;

  return parseInt(quantity);
};

const getRemainingInventory = (item, cart) => {
  const inventoryQuantity = getVariantInventory(item);

  const _items = cart.items.filter((lineItem) => {
    if (lineItem.key !== item.key) {
      return lineItem.id === item.id;
    }
  });

  if (_items.length > 0) {
    const quantities = _items.map((_item) => _item.quantity);
    const remainingInventory =
      inventoryQuantity - quantities.reduce((a, b) => a + b);

    return remainingInventory;
  } else return inventoryQuantity;
};

const getInventoryPolicy = (item) => {
  const cartData = JSON.parse(
    document.querySelector(".quick-cart-wrap").dataset.quickCartItemsValue
  );

  const _item = cartData.find((i) => i.key === item.key);

  return _item?.inventory_policy;
};

export default function CartLineItem(item, cart, max) {
  return `
  <div
  class="line-item"
  data-controller="line-item"
  data-line-item-variant-value="${item.variant_id}"
  data-line-item-key-value="${item.key}"
  data-cart-target="lineItem"
  data-quantity="${item.quantity}"
>
  <img
    class="line-item__image"
    src="${item.featured_image.url}"
    alt="${item.title}"
    height="150"
    width="150"
    loading="lazy"
  />
  <div class="line-item__product">
    <div class="line-item__product-inner">
      <h3>${item.title}</h3>
      <button type="button" class="line-item__remove" data-action="line-item#removeFromCart">
        <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="trash-alt" class="svg-inline--fa fa-trash-alt fa-w-14" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M296 432h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8zm-160 0h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8zM440 64H336l-33.6-44.8A48 48 0 0 0 264 0h-80a48 48 0 0 0-38.4 19.2L112 64H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v368a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V96h24a8 8 0 0 0 8-8V72a8 8 0 0 0-8-8zM171.2 38.4A16.1 16.1 0 0 1 184 32h80a16.1 16.1 0 0 1 12.8 6.4L296 64H152zM384 464a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16V96h320zm-168-32h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8z"></path></svg>
      </button>
    </div>
    ${
      item.selling_plan_allocation
        ? `
    <p class="line-item__subscribe">
      <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="sync-alt" class="svg-inline--fa fa-sync-alt fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M483.515 28.485L431.35 80.65C386.475 35.767 324.485 8 256 8 123.228 8 14.824 112.338 8.31 243.493 7.971 250.311 13.475 256 20.301 256h28.045c6.353 0 11.613-4.952 11.973-11.294C66.161 141.649 151.453 60 256 60c54.163 0 103.157 21.923 138.614 57.386l-54.128 54.129c-7.56 7.56-2.206 20.485 8.485 20.485H492c6.627 0 12-5.373 12-12V36.971c0-10.691-12.926-16.045-20.485-8.486zM491.699 256h-28.045c-6.353 0-11.613 4.952-11.973 11.294C445.839 370.351 360.547 452 256 452c-54.163 0-103.157-21.923-138.614-57.386l54.128-54.129c7.56-7.56 2.206-20.485-8.485-20.485H20c-6.627 0-12 5.373-12 12v143.029c0 10.691 12.926 16.045 20.485 8.485L80.65 431.35C125.525 476.233 187.516 504 256 504c132.773 0 241.176-104.338 247.69-235.493.339-6.818-5.165-12.507-11.991-12.507z"></path></svg>
      ${item.selling_plan_allocation.selling_plan.name}
    </p>`
        : ""
    }
    <div class="line-item__body">
      <div
        class="line-item__quantity-wrap"
      >
        <button type="button" data-action="line-item#decreaseQuantity" data-line-item-target="decrease" ${
          item.quantity <= 1 ? "disabled" : ""
        }>–</button>
        <input
          disabled
          class="line-item__quantity-input"
          value="${item.quantity}"
          data-line-item-target="quantity"
          min="1"
          data-inventory-policy="${getInventoryPolicy(item)}"
          data-variant-inventory="${getVariantInventory(item) || max}"
          max="${getRemainingInventory(item, cart)}"
        />
        <button type="button" data-action="line-item#increaseQuantity" data-line-item-target="increase" ${
          item.quantity === max ? "disabled" : ""
        }>+</button>
      </div>
      <div class="line-item__pricing">
        <p data-line-item-target="itemTotalPrice">${
          document.body.dataset.currency
        }${(item.final_line_price / 100).toFixed(2)}</p>
      </div>
    </div>
  </div>
</div>
  `;
}
